var beaconScrollPosition = 0;  

  document.addEventListener('DOMContentLoaded', function() {      
    Beacon('on', 'close', function() {      
      window.scrollTo(0, beaconScrollPosition);
    });

  });
  
    function openChatBeacon() {    
        beaconScrollPosition = window.scrollY;
        Beacon('open'); 
        Beacon('navigate', '/ask/chat/');  
    }

    function openMessageBeacon() {    
        beaconScrollPosition = window.scrollY;
        Beacon('open'); 
        Beacon('navigate', '/ask/message/'); 
    }
